import apiClient from './apiClient';

/**
 * Wallet Service
 * Handles all wallet and transaction related API calls
 */
class WalletService {
  /**
   * Get wallet balance
   * @returns {Promise} - Wallet balance details
   */
  async getBalance() {
    try {
      const response = await apiClient.get('/wallet/balance');
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get wallet transactions
   * @param {object} params - Query parameters (page, limit, type, etc.)
   * @returns {Promise} - List of transactions
   */
  async getTransactions(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString ? `/wallet/transactions?${queryString}` : '/wallet/transactions';
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get transaction by ID
   * @param {string|number} transactionId - Transaction ID
   * @returns {Promise} - Transaction details
   */
  async getTransactionById(transactionId) {
    try {
      const response = await apiClient.get(`/wallet/transactions/${transactionId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Add money to wallet
   * @param {number} amount - Amount to add
   * @param {string} paymentMethod - Payment method
   * @returns {Promise}
   */
  async addMoney(amount, paymentMethod) {
    try {
      const response = await apiClient.post('/wallet/add-money', {
        amount,
        paymentMethod
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transfer money
   * @param {object} transferData - Transfer details (recipient, amount, etc.)
   * @returns {Promise}
   */
  async transferMoney(transferData) {
    try {
      const response = await apiClient.post('/wallet/transfer', transferData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Withdraw money
   * @param {object} withdrawData - Withdrawal details
   * @returns {Promise}
   */
  async withdrawMoney(withdrawData) {
    try {
      const response = await apiClient.post('/wallet/withdraw', withdrawData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get wallet statement
   * @param {object} params - Date range and filters
   * @returns {Promise} - Wallet statement
   */
  async getStatement(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString ? `/wallet/statement?${queryString}` : '/wallet/statement';
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

// Create and export a singleton instance
const walletService = new WalletService();
export default walletService;

